module.exports = require("lodash/inRange");